import React from 'react';
import { Logo } from './Logo';

/**
 * Footer Component - Rodapé oficial do Receppet
 * Usado em todas as páginas da aplicação
 */
const Footer = ({ className = "" }) => {
    return (
        <footer 
            className={`bg-slate-900 text-white py-12 ${className}`} 
            data-testid="footer"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col md:flex-row justify-between items-center gap-6">
                    <div className="flex items-center gap-2">
                        <Logo size="md" />
                    </div>
                    <div className="text-center md:text-right">
                        <p className="text-slate-400 text-sm">
                            © 2025 Receppet
                        </p>
                        <p className="text-slate-500 text-xs mt-1">
                            Plataforma de serviços para pets
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
